/** */
import React from 'react';
import styles from './acquisition-report.module.css';

export const BreakdownRow = ({ label, count, max }) => (
  <div className={styles.breakdownRow}>
    <span className={styles.breakdownLabel}>{label}</span>
    <div className={styles.breakdownTrack}>
      <div
        className={styles.breakdownFill}
        style={{ width: `${(count / Math.max(1, max)) * 100}%` }}
      />
    </div>
    <span className={styles.breakdownCount}>{count}</span>
  </div>
);
